import { DataPointWithValue } from '@src/types/DataPoint';
import { getDataPointCollectionByPointNamesAndControllerId } from '../utils';

export const CanyonCountry_Device_Points_Config = {
  UNIT_POINTS: [
    {
      label: 'kW',
      pointName: 'kW',
      pointAlias: 'kw',
    },
    {
      label: 'kVAR',
      pointName: 'kVAR',
      pointAlias: 'kvar',
    },
    {
      label: 'SOC',
      pointName: 'SOC',
      pointAlias: 'unitController_SOC_float',
    },
    {
      label: 'Racks Online',
      pointName: 'racksonline',
      pointAlias: 'unitController_racksonline',
    },
    {
      label: 'Inv Status',
      pointName: 'InvStatus',
      pointAlias: 'unitController_InvStatus_string',
    },
    {
      label: 'Run Mode',
      pointName: 'RunMode',
      pointAlias: 'unitController_RunMode_string',
    },
  ],
};

export type UnitController = {
  unitControllerId: string;
  dataPointsWithValues: DataPointWithValue[];
};

export enum UnitControllerSN {
  // F2_C1 = '0215F46A',
  F2_C1 = '0000001F',
  F2_C2 = '0215F4F6',
  F2_C3 = '0215F722',
  F2_C4 = '0215F494',
  F2_C5 = '0215CCCD',
  F2_C6 = '0215F3B8',
  F1_A1 = '0215CD02',
  F1_A2 = '0215F405',
  F1_A3 = '0215F4C0',
  F1_A4 = '0215F77C',
  F1_A5 = '0215F48F',
  F1_A6 = '0215F476',
  F2_D1 = '0215F45F',
  F2_D2 = '0215F3E5',
  F2_D3 = '0215CCCC',
  F2_D4 = '0215CC6B',
  F2_D5 = '0215F5FF',
  F2_D6 = '0215F834',
  F1_B1 = '0215F442',
  F1_B2 = '0215F371',
  F1_B3 = '0215F412',
  F1_B4 = '0215F4D0',
  F1_B5 = '0215F65D',
  F1_B6 = '0215F380',
  F1_B7 = '0215F605',
}

export const getUnitControllerDataPointsWithValues = (
  dataPointsWithValues: DataPointWithValue[],
): UnitController[] => {
  let f2_c1DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_C1,
    dataPointsWithValues: [],
  };

  let f2_c2DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_C2,
    dataPointsWithValues: [],
  };

  let f2_c3DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_C3,
    dataPointsWithValues: [],
  };

  let f2_c4DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_C4,
    dataPointsWithValues: [],
  };

  let f2_c5DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_C5,
    dataPointsWithValues: [],
  };

  let f2_c6DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_C6,
    dataPointsWithValues: [],
  };

  let f1_a1DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_A1,
    dataPointsWithValues: [],
  };

  let f1_a2DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_A2,
    dataPointsWithValues: [],
  };

  let f1_a3DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_A3,
    dataPointsWithValues: [],
  };

  let f1_a4DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_A4,
    dataPointsWithValues: [],
  };

  let f1_a5DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_A5,
    dataPointsWithValues: [],
  };

  let f1_a6DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_A6,
    dataPointsWithValues: [],
  };

  let f2_d1DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_D1,
    dataPointsWithValues: [],
  };

  let f2_d2DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_D2,
    dataPointsWithValues: [],
  };

  let f2_d3DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_D3,
    dataPointsWithValues: [],
  };

  let f2_d4DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_D4,
    dataPointsWithValues: [],
  };

  let f2_d5DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_D5,
    dataPointsWithValues: [],
  };

  let f2_d6DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F2_D6,
    dataPointsWithValues: [],
  };

  let f1_b1DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_B1,
    dataPointsWithValues: [],
  };

  let f1_b2DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_B2,
    dataPointsWithValues: [],
  };

  let f1_b3DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_B3,
    dataPointsWithValues: [],
  };

  let f1_b4DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_B4,
    dataPointsWithValues: [],
  };

  let f1_b5DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_B5,
    dataPointsWithValues: [],
  };

  let f1_b6DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_B6,
    dataPointsWithValues: [],
  };

  let f1_b7DataPointsWithValues: UnitController | undefined = {
    unitControllerId: UnitControllerSN.F1_B7,
    dataPointsWithValues: [],
  };

  const pointNames = CanyonCountry_Device_Points_Config.UNIT_POINTS.map(
    (point) => point.pointName.toLowerCase(),
  );

  f2_c1DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_c1DataPointsWithValues.unitControllerId,
    );

  f2_c2DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_c2DataPointsWithValues.unitControllerId,
    );

  f2_c3DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_c3DataPointsWithValues.unitControllerId,
    );

  f2_c4DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_c4DataPointsWithValues.unitControllerId,
    );

  f2_c5DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_c5DataPointsWithValues.unitControllerId,
    );

  f2_c6DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_c6DataPointsWithValues.unitControllerId,
    );

  f1_a1DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_a1DataPointsWithValues.unitControllerId,
    );

  f1_a2DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_a2DataPointsWithValues.unitControllerId,
    );

  f1_a3DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_a3DataPointsWithValues.unitControllerId,
    );

  f1_a4DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_a4DataPointsWithValues.unitControllerId,
    );

  f1_a5DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_a5DataPointsWithValues.unitControllerId,
    );

  f1_a6DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_a6DataPointsWithValues.unitControllerId,
    );

  f2_d1DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_d1DataPointsWithValues.unitControllerId,
    );

  f2_d2DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_d2DataPointsWithValues.unitControllerId,
    );

  f2_d3DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_d3DataPointsWithValues.unitControllerId,
    );

  f2_d4DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_d4DataPointsWithValues.unitControllerId,
    );

  f2_d5DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_d5DataPointsWithValues.unitControllerId,
    );

  f2_d6DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f2_d6DataPointsWithValues.unitControllerId,
    );

  f1_b1DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_b1DataPointsWithValues.unitControllerId,
    );

  f1_b2DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_b2DataPointsWithValues.unitControllerId,
    );

  f1_b3DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_b3DataPointsWithValues.unitControllerId,
    );

  f1_b4DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_b4DataPointsWithValues.unitControllerId,
    );

  f1_b5DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_b5DataPointsWithValues.unitControllerId,
    );

  f1_b6DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_b6DataPointsWithValues.unitControllerId,
    );

  f1_b7DataPointsWithValues.dataPointsWithValues =
    getDataPointCollectionByPointNamesAndControllerId(
      dataPointsWithValues,
      pointNames,
      f1_b7DataPointsWithValues.unitControllerId,
    );

  return [
    f2_c1DataPointsWithValues,
    f2_c2DataPointsWithValues,
    f2_c3DataPointsWithValues,
    f2_c4DataPointsWithValues,
    f2_c5DataPointsWithValues,
    f2_c6DataPointsWithValues,
    f1_a1DataPointsWithValues,
    f1_a2DataPointsWithValues,
    f1_a3DataPointsWithValues,
    f1_a4DataPointsWithValues,
    f1_a5DataPointsWithValues,
    f1_a6DataPointsWithValues,
    f2_d1DataPointsWithValues,
    f2_d2DataPointsWithValues,
    f2_d3DataPointsWithValues,
    f2_d4DataPointsWithValues,
    f2_d5DataPointsWithValues,
    f2_d6DataPointsWithValues,
    f1_b1DataPointsWithValues,
    f1_b2DataPointsWithValues,
    f1_b3DataPointsWithValues,
    f1_b4DataPointsWithValues,
    f1_b5DataPointsWithValues,
    f1_b6DataPointsWithValues,
    f1_b7DataPointsWithValues,
  ];
};
